/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setTaxInformation} from '../api'

export const useMutationSetTaxInformation = createReactQueryMutationHook('setTaxInformation', setTaxInformation)
